<template lang="pug">
label.input-text
  .input-text__label Phone
  input.input-text__input(
    type="tel"
    placeholder=""
    v-model.trim="value"
    @keyup="changeFieldValue()"
    v-maska="['+1 (###) ###-####', '+1 (###) ###-####']"
  )
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'

export default {
  name: 'FieldPhone',

  data () {
    return {
      value: ''
    }
  },

  computed: {
    ...mapGetters([
      'fieldPhone'
    ])
  },

  methods: {
    ...mapMutations([
      'changeField'
    ]),

    changeFieldValue () {
      this.changeField({
        name: 'fieldPhone',
        value: this.value
      })
    }
  },

  created() {
    this.value = this.fieldPhone
  }
}
</script>
